<ion-header>
  <ion-toolbar>
    <ion-title>{{ fileName }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="zoomOut()" [disabled]="zoom <= 0.5">
        <ion-icon name="remove-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="resetZoom()">
        <span class="zoom-label">{{ zoom * 100 | number: '1.0-0' }}%</span>
      </ion-button>
      <ion-button (click)="zoomIn()" [disabled]="zoom >= 5">
        <ion-icon name="add-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="_modalCtrl.dismiss()">
        <span color="primary" *ngIf="isIos"> {{ 'CANCEL_BUTTON' | translate }} </span>
        <ion-icon name="close" *ngIf="!isIos"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="pdfBox">
  <pdf-viewer
    class="pdfViewer"
    [src]="src"
    [render-text]="true"
    [original-size]="false"
    [(page)]="currentPage"
    [zoom]="zoom"
    [zoom-scale]="'page-width'"
  ></pdf-viewer>
</div>
